const PH_GIFTS=[
  {amount:1000, variant:42872110907476, tag:'gift-1000'},
  {amount:4000, variant:42872110940244, tag:'gift-4000'}
];

async function getCart(){return fetch('/cart.js').then(r=>r.json());}
async function addGift(variant){
  return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({id:variant,quantity:1,properties:{_auto_gift:'true'}})});
}
async function removeGift(key){
  return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({id:key,quantity:0})});
}

async function handlePHGifts(){
  const cart=await getCart();
  const total=cart.total_price/100;

  for(const g of PH_GIFTS){
    const autoItem=cart.items.find(i=>i.properties?._auto_gift==='true' && i.variant_id===g.variant);
    if(total>=g.amount && !autoItem){
      await addGift(g.variant);
      document.dispatchEvent(new Event('cart:refresh'));
    }
    if(total<g.amount && autoItem){
      await removeGift(autoItem.key);
      document.dispatchEvent(new Event('cart:refresh'));
    }
  }
}
document.addEventListener('cart:updated',handlePHGifts);
document.addEventListener('cart:refresh',handlePHGifts);
document.addEventListener('DOMContentLoaded',handlePHGifts);
handlePHGifts();